<template lang="pug">
    section.ai-pika-examples.section
        ._wrap.wrap
            h2._title {{ content.titleLine1 }}
                br/ {{ content.titleLine2 }}
            perfect-scrollbar._list
                picture
                  source(:srcset="require('../../../assets/images/ai-pika-examples/1.webp')" type="image/webp")
                  img(:src="require('../../../assets/images/ai-pika-examples/1.png')" loading="lazy" sizes="(max-width: 768px) 50vw, (max-width: 1200px) 33vw, 25vw")._image
                picture
                  source(:srcset="require('../../../assets/images/ai-pika-examples/2.webp')" type="image/webp")
                  img(:src="require('../../../assets/images/ai-pika-examples/2.png')" loading="lazy" sizes="(max-width: 768px) 50vw, (max-width: 1200px) 33vw, 25vw")._image
                picture
                  source(:srcset="require('../../../assets/images/ai-pika-examples/3.webp')" type="image/webp")
                  img(:src="require('../../../assets/images/ai-pika-examples/3.png')" loading="lazy" sizes="(max-width: 768px) 50vw, (max-width: 1200px) 33vw, 25vw")._image
            ._idea
                picture
                  source(:srcset="require('../../../assets/images/ai-pika-examples/idea-bg.webp')" type="image/webp")
                  img(:src="require('../../../assets/images/ai-pika-examples/idea-bg.jpg')" loading="lazy" sizes="(max-width: 768px) 100vw, 50vw")._idea-background
                ._idea-content
                    ._idea-title {{ content.idea }}
                    ui-button(variant="rounded" text="Попробовать Pika" :loading="isLoading" @click="handleLoginClick")._idea-btn
            ui-button(variant="rounded" text="Попробовать Pika" :loading="isLoadingSmall" @click="handleLoginClick")._idea-btn.-small
</template>

<script>
import UiButton from "@/components/ui/ui-button/ui-button.vue";
import aiStatic from "@/seo/ai-static.json";

export default {
    name: "AiPikaExamples",
    components: { UiButton },
    data() {
        return {
            // Текст лежит в ai-static.json: тот же файл использует выгрузка HTML для поисковых ботов
            content: aiStatic.pikaExamples,
            isLoading: false,
            isLoadingSmall: false,
        };
    },
    methods: {
        handleLoginClick() {
            this.isLoading = true;
            this.isLoadingSmall = true;
            this.$router.push("/welcome/login");
        },
    },
};
</script>

<style lang="scss" src="./ai-pika-examples.scss"></style>
